import $ from 'jquery';

const $heroBanner = $('.hero-banner');
const $player = $('.hero-banner__video');
const $btnWrapper = $('.hero-banner__video-controls-wrapper');

/* Init module */
const init = () => {
  $player.show();
  $btnWrapper.show();
  $heroBanner.addClass('video');
  if (!$player.attr('autoplay')) {
    $player.attr('autoplay', '');
  }
};

window.addEventListener('load', function () {
  // custom video controls - play and pause
  const $playPauseBtn = $('.play');

  if ($playPauseBtn && $playPauseBtn.length) {
    // remove native controls
    $player.removeAttr('controls');

    $playPauseBtn.on('click', function (e) {
      e.preventDefault();
      const $video = $(this).closest('.hero-banner').find('.hero-banner__video');

      if ($video.prop('paused') == true) {
        $video.trigger('play');
        $(this).addClass('pause');
      } else {
        $video.trigger('pause');
        $(this).removeClass('pause');
      }
    });
  }
});

$(window).on('load', function () {
  $player.length && init();
});